<template>
  <div class="dialog-content">
    <!--        设备主界面-->
    <el-row class="dialog-content">
      <el-col :span="12" style="height: 100% ; border-right: 1px solid rgba(41, 155, 255, .2)">
        <div class="deviceDetailContentHeight text-center">
          <div
            class="bg-color" style="overflow-y:auto;width: 100%;height: 100%;padding-top: 10px;">

            <ul class="videoUl">
              <span style="float:left">监控画面:</span>
              <li class="videoLi one">
                <video-component :channel="1" :device-info="deviceInfo"
                                 :properties="portProperties"></video-component>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <!--        测点数据-->

      <el-col :span="12" style="height: 100%; ">
        <div class="deviceDetailContentHeight text-center">
          <div
            class="bg-color" style="overflow-y:auto;width: 100%;height: 100%;padding-top: 10px;">
            <Elevator-layout />

          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VideoComponent from "@/components/video/VideoComponent";
import {getDeviceInfo} from "@/network/device-info";
import ElevatorLayout from "@/components/device_details/comp/ElevatorLayout";
export default {
  name: "Door",
  components: {VideoComponent,ElevatorLayout},
  props: ['deviceInfo'],
  mounted() {
    this.getDeviceInfo();
  },
  data() {
    return {
      portProperties: null,
      channel: "1",
      channelList: [{
        id: "1",
        name: "1x1",
      }, {
        id: "4",
        name: "2x2",
      }, {
        id: "9",
        name: "3x3",
      }, {
        id: "16",
        name: "4x4",
      }, {
        id: "25",
        name: "5x5",
      }, {
        id: "36",
        name: "6x6",
      }],
      channels: [0],
    }
  },
  methods: {
    getDeviceInfo() {
      getDeviceInfo(this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.portProperties = JSON.parse(res.data.portProperties)
        }
      })
    },
    change(id) {
      this.channels = []
      for (let i = 0; i < id; i++) {
        this.channels.push(i)
      }
      console.log(this.channels);
    }
  }
}
</script>

<style scoped>
.videoUl {
  width: 85%;
  height: 75%;
  margin: auto;
  padding-left: 0;
  padding-top: 70px;
}

.videoLi {
  float: left;
  list-style: none;
}

.one {
  width: 100%;
  height: 100%;
}
</style>
